// extracted by mini-css-extract-plugin
export default {"block":"MoreButton_block__6QqbA","opened":"MoreButton_opened__Bh0RC"};